import { Icons } from './icons';
import { MenuItem } from './MenuItem';
import { MenuRow } from './MenuList';

interface Props {
  /** Visible, already translated labels (they name the thing being moved). */
  upLabel: string;
  downLabel: string;
  /** `false` at the start / end of the list: the item stays, disabled. */
  canMoveUp: boolean;
  canMoveDown: boolean;
  onUp: () => void;
  onDown: () => void;
  disabled?: boolean;
}

/**
 * "Move up" / "Move down" rows of a resource menu. The glyphs point where the item goes (up /
 * down), the first item cannot go further up and the last cannot go further down (disabled, not
 * hidden, so the menu keeps its shape and a screen reader announces why).
 */
export function MoveMenuItems({
  upLabel,
  downLabel,
  canMoveUp,
  canMoveDown,
  onUp,
  onDown,
  disabled = false,
}: Props) {
  return (
    <>
      <MenuRow>
        <MenuItem
          icon={<Icons.arrowUp />}
          disabled={disabled || !canMoveUp}
          onClick={onUp}
          data-move="up"
        >
          {upLabel}
        </MenuItem>
      </MenuRow>
      <MenuRow>
        <MenuItem
          icon={<Icons.arrowDown />}
          disabled={disabled || !canMoveDown}
          onClick={onDown}
          data-move="down"
        >
          {downLabel}
        </MenuItem>
      </MenuRow>
    </>
  );
}
